import { render, staticRenderFns } from "./CustomCompanyContent.vue?vue&type=template&id=2d93f914&"
import script from "./CustomCompanyContent.vue?vue&type=script&lang=js&"
export * from "./CustomCompanyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports